module.exports = __webpack_public_path__ + "static/media/pricing_reload.ad8cf626.svg";